export default __webpack_public_path__ + "static/media/incontrol-1.a05f49f4.png";